import { ref } from '@vue/composition-api'

export default () => {
  const resolveNavItemComponent = item => {
    // Si tiene subheader con texto -> section title
    if (item.subheader) return 'vertical-nav-menu-section-title'
    // Si tiene subheader vacío (propiedad existe pero sin valor) -> divider
    if ('subheader' in item) return 'vertical-nav-menu-divider'
    if (item.children) return 'vertical-nav-menu-group'

    return 'vertical-nav-menu-link'
  }

  const isMouseHovered = ref(false)

  return {
    isMouseHovered,
    resolveNavItemComponent,
  }
}
